export default "__VITE_ASSET__107bf1bf__"